// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReloadCostsBannerQueryVariables = Types.Exact<{
  filter: Types.CostConfigurationSummariesFilter;
}>;


export type ReloadCostsBannerQuery = { __typename?: 'Query', costConfigurationSummaries: { __typename?: 'CostConfigurationSummariesPage', entities: Array<{ __typename?: 'CostConfigurationSummary', id: string }> } };


export const ReloadCostsBannerDocument = gql`
    query ReloadCostsBanner($filter: CostConfigurationSummariesFilter!) {
  costConfigurationSummaries(filter: $filter) {
    entities {
      id
    }
  }
}
    `;

/**
 * __useReloadCostsBannerQuery__
 *
 * To run a query within a React component, call `useReloadCostsBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReloadCostsBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReloadCostsBannerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReloadCostsBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables> & ({ variables: ReloadCostsBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>(ReloadCostsBannerDocument, options);
      }
export function useReloadCostsBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>(ReloadCostsBannerDocument, options);
        }
// @ts-ignore
export function useReloadCostsBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>;
export function useReloadCostsBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReloadCostsBannerQuery | undefined, ReloadCostsBannerQueryVariables>;
export function useReloadCostsBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>(ReloadCostsBannerDocument, options);
        }
export type ReloadCostsBannerQueryHookResult = ReturnType<typeof useReloadCostsBannerQuery>;
export type ReloadCostsBannerLazyQueryHookResult = ReturnType<typeof useReloadCostsBannerLazyQuery>;
export type ReloadCostsBannerSuspenseQueryHookResult = ReturnType<typeof useReloadCostsBannerSuspenseQuery>;
export type ReloadCostsBannerQueryResult = ApolloReactCommon.QueryResult<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>;